import CircularLoader from '../CircularLoader/CircularLoader';
import styles from './Button.module.css';
import type { ButtonProps } from './types/ButtonProps';

const Button = ({
  children,
  className = '',
  disabled = false,
  loader = false,
  outlined = false,
  textOnly = false,
  fullWidth = false,
  underlined = false,
  ...props
}: ButtonProps) => {
  return (
    <button
      className={`${styles.button} ${outlined ? styles.outlined : ''} ${textOnly ? styles.textOnly : ''} ${fullWidth ? styles.fullWidth : ''} ${underlined ? styles.underlined : ''} ${disabled && !loader ? styles.disabled : ''} ${className}`}
      disabled={disabled || loader}
      {...props}
    >
      {loader ? <CircularLoader color={'#ffffff'} size={24} /> : children}
    </button>
  );
};

export default Button;
